export default __webpack_public_path__ + "static/media/section1-bg.ad41e3a0.png";